import { FULL_BULLETINS, GLOBAL_CATALOGS, HAS_DETAILS } from '../types';
import { queryAllContentList, queryContentList } from './cmsAction';


export const queryNotificationMenus = (list = []) => (dispatch, getState) => {
  dispatch({
    type: GLOBAL_CATALOGS.Bulletins.Root,
    payload: list
  });
};


/* ************************************************************** */ 
export const queryLastNewsList = ({ contentCode = GLOBAL_CATALOGS.Bulletins.LatestNews.List, title, ruleTag, page = 1, rowsPerPage = 10 }) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_BULLETINS.Loading,
    payload: true
  });

  await dispatch({
    type: FULL_BULLETINS.FilterService,
    payload: contentCode
  });
  
  const response = await dispatch(queryAllContentList({ contentCode, hasDetails: HAS_DETAILS.True, ruleTag, title, page, rowsPerPage }));
  
  await dispatch({
    type: GLOBAL_CATALOGS.Bulletins.LatestNews.List,
    payload: response
  });

  setTimeout(() => {
    dispatch({
      type: FULL_BULLETINS.Loading,
      payload: false
    });
  }, 260);
};
/* ************************************************************** */ 
